module.exports = __webpack_public_path__ + "static/media/Desktop_WhatIsCulture_11.bdd283ee.png";